<script setup lang="ts">

import PanelCard from "@/views/shared/components/PanelCard.vue";
import PanelGrid from "@/views/shared/components/PanelGrid.vue";
import { useRoute, useRouter } from "vue-router";
import { ref, computed } from "vue";
import { useProject } from "@/queries/projects";
import { useCreateWorkflow } from "@/queries/workflows";
import PageHeader from "@/components/PageHeader.vue";
import BlockUI from "@/components/BlockUI.vue";
import FormAlert from "@/components/FormAlert.vue";

const route = useRoute();
const router = useRouter();

const projectId = computed(() => (route.params.projectid as string) || "");
const { project, projectLoading: loading } = useProject(projectId);
const { createWorkflow, createWorkflowPending, createWorkflowError, createWorkflowReset } = useCreateWorkflow();

const workflowName = ref("");

function handleSubmit(event: Event) {
  event.preventDefault();

  if (!workflowName.value.trim()) {
    return;
  }

  createWorkflow({ projectId: projectId.value, name: workflowName.value }, {
    onSuccess: (workflowId) => {
      router.push(`/projects/${projectId.value}/builder/${workflowId}`);
    },
  });
}

</script>

<template>
  <PanelGrid :columns="1">
    <PanelCard>


      <PageHeader title="New Workflow" :breadcrumbs="[
        { label: 'Dashboard', href: '/' },
        { label: 'Projects', href: '/projects' },
        { label: project?.name ?? '', href: `/projects/${projectId}/workflows` },
        { label: 'Builder', href: `/projects/${projectId}/builder` },
        { label: 'New' }
      ]">


      </PageHeader>
      <BlockUI :active="createWorkflowPending">
      <FormAlert :error="createWorkflowError" @dismiss="createWorkflowReset" />
      <div class="col-12 col-lg-8 col-xl-6">
      <form @submit="handleSubmit">
        <div class="row mb-3">
          <label for="inputProject" class="col-sm-3 col-form-label">Project</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="inputProject"  :value="project?.name ?? ''" readonly>
          </div>
        </div>
            <div class="row mb-3">
              <label for="inputName" class="col-sm-3 col-form-label">Workflow Name <span class="text-danger">*</span></label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  id="inputName"
                  v-model="workflowName"
                  required
                  minlength="3"
                >
              </div>
            </div>
            <div class="row">
              <div class="col-sm-9 offset-sm-3">
                <div class="d-flex justify-content-end gap-2">
                  <button type="button" class="bb-btn-cancel" @click="router.back()">
                    Cancel
                  </button>
                  <button type="submit" class="bb-btn-primary-cta" :disabled="loading || createWorkflowPending">
                    {{ createWorkflowPending ? 'Creating...' : 'Create' }}
                  </button>
                </div>
              </div>
            </div>
          </form>
          </div>
      </BlockUI>

    </PanelCard>
  </PanelGrid>
</template>

<style scoped lang="scss">

</style>
